;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();export const fragment = /* GraphQL */ `
    fragment CardColumnContentFragment on CardColumnContent {
        entryTitle
        eyebrow
        headline
        richBodyCopy {
            json
        }
        image {
            ...Asset
        }
        imageLarge {
            ...Asset
        }
        cta {
            ...CTA
        }
        cta2 {
            ...CTA
        }
        backgroundTheme
    }
`;
